import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import PlusIcon from 'components/v2/icons/PlusIcon';
import ContactField from './ContactField';
import LocationAutosuggest from '../../../site/location-autosuggest';

class LocationDetails extends Component {
  static propTypes = {
    id: PropTypes.string,
    locationNameId: PropTypes.string,
    locationAddressId: PropTypes.string,
    sectionTitle: PropTypes.string.isRequired,
    errors: PropTypes.object,
    details: PropTypes.shape({
      name: PropTypes.string,
      contacts: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          email: PropTypes.string,
          phone: PropTypes.string,
        }),
      ),
      location_type: PropTypes.string,
      location: PropTypes.shape({
        name: PropTypes.string,
        address: PropTypes.string,
      }),
    }),
    children: PropTypes.any,
    onAddContact: PropTypes.func.isRequired,
    onRemoveContact: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onContactFieldChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    errors: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      address: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      details: {
        location: { address },
      },
    } = this.props;

    const {
      details: {
        location: { address: nextAddress },
      },
    } = nextProps;

    if (address !== nextAddress) {
      this.setState({
        address: nextAddress,
      });
    }
  }

  handleFieldChange = (field) => (e) =>
    this.props.onChange(field, e.target.value);
  handleDateFieldChange = (field) => (value) =>
    this.props.onChange(field, value);
  handleAddContact = () => this.props.onAddContact();
  handleRemoveContact = (i) => () => this.props.onRemoveContact(i);
  handleContactFieldChange = (i) => (field, value) => {
    this.props.onContactFieldChange(i, field, value);
  };
  handleLocationAddressSelect = (item) => {
    const { address } = item;
    const { lat, lng, place_id } = item;
    const coords = [lng, lat];

    const {
      details: { location: currentLocation },
    } = this.props;

    const location = Object.assign(
      { ...currentLocation },
      {
        ...coords,
        lat,
        lng,
        address,
        place_id,
      },
    );
    this.setState({ address });
    this.props.onChange('location', location);
  };

  renderLocationFields() {
    const {
      details: { location_type, name },
      t,
    } = this.props;

    let dataTestId;
    if (this.props.id === 'order-origin-details') {
      dataTestId = 'origin-location-type-select';
    } else if (this.props.id === 'order-destination-details') {
      dataTestId = 'destination-location-type-select';
    } else {
      dataTestId = undefined;
    }
    return (
      <>
        <div className="">
          <fieldset className="">
            <label className="form-label block mb-2">
              {t('LOCATION_TYPE')}
            </label>
            <select
              className="mb-4 w-full form-select"
              value={location_type}
              onChange={this.handleFieldChange('location_type')}
              data-testid={dataTestId}
            >
              <option value="">{t('SELECT_LOCATION_TYPE')}</option>
              <option value="terminal">
                {t('TERMINAL_PORT_CONTAINER_YARD')}
              </option>
              <option value="customer">{titleize(t('CUSTOMER'))}</option>
            </select>
          </fieldset>
        </div>
        {this.renderAddress()}
        <div className="">
          <fieldset className="">
            <label className="form-label mb-2 block">
              {titleize(t('NAME', { count: 1 }))}
            </label>
            <input
              id={this.props.locationNameId}
              className="form-field mb-4 w-full block"
              value={name}
              placeholder={titleize(t('NAME', { count: 1 }))}
              onChange={this.handleFieldChange('name')}
            />
          </fieldset>
        </div>
      </>
    );
  }
  renderContacts() {
    const {
      details: { contacts },
      t,
    } = this.props;

    return (
      <div className="contacts mb-4">
        <label className="mb-2 form-label">
          {titleize(t('CONTACT', { count: 2 }))}
        </label>
        {(contacts || []).map((contact, i) => (
          <ContactField
            contact={contact}
            key={i}
            onChange={this.handleContactFieldChange(i)}
            onRemove={this.handleRemoveContact(i)}
          />
        ))}
      </div>
    );
  }
  renderAddress() {
    const { errors, t } = this.props;
    const error = errors.hasOwnProperty('address');
    const className = classnames({
      error,
    });
    return (
      <div className="">
        <fieldset className={className}>
          <label className="form-label mb-2 block">{t('ADDRESS')} *</label>
          <LocationAutosuggest
            key={this.state.address}
            id={this.props.locationAddressId}
            name={this.state.name}
            address={this.state.address}
            value={this.state.address}
            suggestions={[
              { name: this.state.name, address: this.state.address },
            ]}
            callbackSelectedItem={this.handleLocationAddressSelect}
          />
        </fieldset>
      </div>
    );
  }
  render() {
    const { sectionTitle, details, t } = this.props;
    const contacts = details.contacts || [];
    return (
      <section className="mb-4" id={this.props.id}>
        <h4 className="text-grey-dark">{sectionTitle}</h4>
        <div className="sm:grid sm:grid-cols-4 sm:gap-x-4 gap-y-4">
          {this.renderLocationFields()}
          {this.props.children}
          <div className="col-span-3">
            {this.renderContacts()}
            {contacts.length < 1 && (
              <button
                className="mb-4 button button-hollow-green"
                onClick={this.handleAddContact}
              >
                <div className="flex items-center space-x-1">
                  <PlusIcon />
                  <span>{t('CONTACT', { count: 1 })}</span>
                </div>
              </button>
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default withTranslation()(LocationDetails);
